import { useEffect, useState } from "react";
import { navLinks, site } from "@/mocks/manga";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${solid ? "bg-background-50/95 backdrop-blur border-b border-background-200/70" : "bg-transparent"}`}>
      <nav className="mx-auto flex h-16 w-full items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg"></i>
          </span>
          <span className={`font-heading text-lg font-bold ${solid ? "text-foreground-950" : "text-background-50"}`}>
            {site.name}
          </span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors hover:bg-primary-100/70 ${solid ? "text-foreground-700 hover:text-primary-700" : "text-background-100/90 hover:bg-white/10 hover:text-background-50"}`}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#update"
            className="ml-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            立即追更
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className={`flex h-10 w-10 items-center justify-center rounded-md md:hidden ${solid ? "text-foreground-900" : "text-background-50"}`}
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-primary-100/70"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#update"
              onClick={() => setOpen(false)}
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              立即追更
            </a>
          </div>
        </div>
      )}
    </header>
  );
}